import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface Banner {
  id: number;
  caption: string;
  title: string;
  start_date: string;
  end_date: string;
  active: number | string | boolean;
  cta: string;
  banner_image?: string;
  file_path?: string;
  filename?: string;
  image?: string;
  file?: string;
  path?: string;
  image_path?: string;
  banner_image_path?: string;
  mode?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
  product_id?: number;
  media_type?: 'image' | 'video'; // NEW: track media type
}

export interface ListBannersResponse {
  error: boolean;
  banners: Banner[];
}

export interface AddBannerResponse {
  error: boolean;
  message: string;
  bannerId?: number;
}

export interface UpdateBannerResponse {
  error: boolean;
  message: string;
  banner?: Banner;
}

export interface DeleteBannerResponse {
  error: boolean;
  message: string;
}

export const bannerApi = createApi({
  reducerPath: 'bannerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey',
        '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      return headers;
    },
  }),
  tagTypes: ['Banner'],
  endpoints: (build) => ({
    listBanners: build.query<ListBannersResponse, void>({
      query: () => ({
        url: 'product/bannerlist',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Banner'],
    }),
    addBanner: build.mutation<AddBannerResponse, FormData>({
      query: (formData) => ({
        url: 'product/banneradd',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Banner'],
    }),
    updateBanner: build.mutation<UpdateBannerResponse, { id: number; formData: FormData }>({
      query: ({ id, formData }) => {
        formData.append('id', id.toString());
        return {
          url: 'product/bannerupdate',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['Banner'],
    }),
    deleteBanner: build.mutation<DeleteBannerResponse, number>({
      query: (bannerId) => ({
        url: 'product/bannerdelete',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          id: bannerId.toString(),
        }),
      }),
      invalidatesTags: ['Banner'],
    }),
  }),
});

export const {
  useListBannersQuery,
  useAddBannerMutation,
  useUpdateBannerMutation,
  useDeleteBannerMutation,
} = bannerApi;